export default "__VITE_ASSET__4Z5Jzywd__"